export function extractErrorMsg(e, defaultMsg) {
  return (
    e?.msg || e?.data?.msg || e?.message || defaultMsg || 'Unexpected Error'
  );
}
